/* ============================================
   NDEAVOUR / ODED Sports – Shopify Theme JS
   ============================================ */

// ── UGC CAROUSEL ──
var ugcIndex = 0;

function ugcPlayVideo(video) {
  if (video.readyState >= 2) {
    video.play().catch(function() {});
  } else {
    video.load();
    video.addEventListener('canplay', function() {
      video.play().catch(function() {});
    }, { once: true });
  }
}

function ugcUpdate() {
  var stage = document.querySelector('.ugc-stage');
  if (!stage) return;
  if (window.innerWidth <= 900) return;

  var items = stage.querySelectorAll('.ugc-item');
  var total = items.length;
  var prev = (ugcIndex - 1 + total) % total;
  var next = (ugcIndex + 1) % total;

  items.forEach(function(item, i) {
    var video = item.querySelector('video');
    var soundBtn = item.querySelector('.ugc-sound');
    item.classList.remove('ugc-active', 'ugc-side', 'ugc-hidden');

    if (i === ugcIndex) {
      item.classList.add('ugc-active');
      item.style.order = '2';
      item.onclick = null;
      if (video) { video.muted = true; ugcPlayVideo(video); }
      if (soundBtn) soundBtn.style.display = 'flex';
    } else if (i === prev || i === next) {
      item.classList.add('ugc-side');
      item.style.order = i === prev ? '1' : '3';
      if (video) { video.muted = true; ugcPlayVideo(video); }
      if (soundBtn) soundBtn.style.display = 'none';
      (function(idx) {
        item.onclick = function() { ugcIndex = idx; ugcUpdate(); };
      })(i);
    } else {
      item.classList.add('ugc-hidden');
      item.style.order = '0';
      item.onclick = null;
      if (video) { video.muted = true; video.pause(); }
      if (soundBtn) soundBtn.style.display = 'none';
    }
  });
}

function ugcPrev() {
  var stage = document.querySelector('.ugc-stage');
  if (!stage) return;
  ugcIndex = (ugcIndex - 1 + stage.querySelectorAll('.ugc-item').length) % stage.querySelectorAll('.ugc-item').length;
  requestAnimationFrame(ugcUpdate);
}

function ugcNext() {
  var stage = document.querySelector('.ugc-stage');
  if (!stage) return;
  ugcIndex = (ugcIndex + 1) % stage.querySelectorAll('.ugc-item').length;
  requestAnimationFrame(ugcUpdate);
}

// ── UGC MOBILE INFINITE CAROUSEL ──
function ugcMobileInit() {
  if (window.innerWidth > 900) return;
  var stage = document.querySelector('.ugc-stage');
  if (!stage || stage.dataset.mobileInit) return;
  stage.dataset.mobileInit = '1';

  // Reset desktop classes
  var realItems = Array.from(stage.querySelectorAll('.ugc-item'));
  realItems.forEach(function(item) {
    item.classList.remove('ugc-hidden', 'ugc-side', 'ugc-active');
    item.style.order = ''; item.onclick = null;
  });

  var total = realItems.length;

  // Clone full set before and after for infinite loop
  realItems.slice().reverse().forEach(function(el) {
    var c = el.cloneNode(true); c.dataset.clone = '1';
    stage.insertBefore(c, stage.firstChild);
  });
  realItems.forEach(function(el) {
    var c = el.cloneNode(true); c.dataset.clone = '1';
    stage.appendChild(c);
  });
  // Layout: [clones 0-4] [real 5-9] [clones 10-14]

  var mIdx = total; // start at first real item

  function itemW() {
    var el = stage.querySelector('.ugc-item');
    return el ? el.getBoundingClientRect().width + 14 : window.innerWidth * 0.78 + 14;
  }
  function offset() {
    var el = stage.querySelector('.ugc-item');
    var w = el ? el.getBoundingClientRect().width : window.innerWidth * 0.78;
    return (window.innerWidth - w) / 2;
  }

  function moveTo(idx, animate) {
    var x = offset() - idx * itemW();
    stage.style.transition = animate ? 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)' : 'none';
    stage.style.transform = 'translateX(' + x + 'px)';
    var all = stage.querySelectorAll('.ugc-item');
    all.forEach(function(item, i) {
      var v = item.querySelector('video');
      if (!v) return;
      if (i === idx) { v.muted = true; v.play().catch(function() {}); }
      else { v.pause(); }
    });
  }

  moveTo(mIdx, false);

  var touchStartX = 0, touchStartY = 0, dragging = false;

  stage.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    dragging = true;
  }, { passive: true });

  stage.addEventListener('touchend', function(e) {
    if (!dragging) return;
    dragging = false;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < Math.abs(dy) || Math.abs(dx) < 40) return;
    mIdx += dx < 0 ? 1 : -1;
    moveTo(mIdx, true);
    setTimeout(function() {
      if (mIdx >= total * 2) { mIdx -= total; moveTo(mIdx, false); }
      else if (mIdx < total) { mIdx += total; moveTo(mIdx, false); }
    }, 380);
  }, { passive: true });

  // Mouse drag support for desktop browsers in mobile view
  var mouseStartX = 0, mouseDragging = false;
  stage.addEventListener('mousedown', function(e) {
    mouseDragging = true;
    mouseStartX = e.clientX;
    stage.style.cursor = 'grabbing';
    e.preventDefault();
  });
  document.addEventListener('mouseup', function(e) {
    if (!mouseDragging) return;
    mouseDragging = false;
    stage.style.cursor = '';
    var dx = e.clientX - mouseStartX;
    if (Math.abs(dx) < 40) return;
    mIdx += dx < 0 ? 1 : -1;
    moveTo(mIdx, true);
    setTimeout(function() {
      if (mIdx >= total * 2) { mIdx -= total; moveTo(mIdx, false); }
      else if (mIdx < total) { mIdx += total; moveTo(mIdx, false); }
    }, 380);
  });
}

function ugcToggleSound(btn) {
  var video = btn.closest('.ugc-item').querySelector('video');
  if (!video) return;
  video.muted = !video.muted;
  btn.textContent = video.muted ? '🔇' : '🔊';
}

// Debounce resize to avoid blocking main thread on every resize event
var _ugcResizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(_ugcResizeTimer);
  _ugcResizeTimer = setTimeout(ugcUpdate, 150);
}, { passive: true });

// ── NAVIGATION ──
function toggleMenu() {
  var hb = document.getElementById('hamburger');
  var dd = document.getElementById('navDropdown');
  if (!hb || !dd) return;
  var isOpen = hb.classList.contains('open');
  if (isOpen) {
    hb.classList.remove('open');
    dd.classList.remove('open');
    dd.style.display = 'none';
  } else {
    hb.classList.add('open');
    dd.classList.add('open');
    dd.style.display = 'flex';
    dd.style.flexDirection = 'column';
  }
}

function closeMenu() {
  var hb = document.getElementById('hamburger');
  var dd = document.getElementById('navDropdown');
  if (hb) hb.classList.remove('open');
  if (dd) { dd.classList.remove('open'); dd.style.display = 'none'; }
}

// ── FAQ ACCORDION ──
function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      // Defer DOM mutations out of the click handler to reduce INP
      requestAnimationFrame(function() {
        document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  });
}

// ── PAKKET SELECTOR ──
function selectPakket(id) {
  var clickedItem = document.querySelector('[data-pakket="' + id + '"]');
  var isSelected = clickedItem && clickedItem.classList.contains('selected');
  // Read state before rAF (no layout forced here)
  var label = (clickedItem && clickedItem.dataset.btnLabel) || 'In winkelwagen';
  if (!isSelected) {
    selectedPakket = id;
    // Defer all DOM mutations to next frame to reduce INP
    requestAnimationFrame(function() {
      document.querySelectorAll('.pkg-card-v2').forEach(function(item) { item.classList.remove('selected'); });
      if (clickedItem) clickedItem.classList.add('selected');
      var cta = document.getElementById('pakketCta');
      if (cta) {
        cta.textContent = label;
        cta.className = 'btn btn-orange add-cart-btn';
        cta.style.cssText = 'width:100%;text-align:center;display:block;margin-top:16px;';
        cta.href = '/cart';
      }
      var addBtn = document.querySelector('.add-cart-btn');
      if (addBtn) addBtn.textContent = label;
      // Show Mix button only for value pack
      document.querySelectorAll('[data-mix]').forEach(function(btn) {
        btn.style.display = id === 'valuepack' ? '' : 'none';
      });
      // Reset to Mango if switching away from valuepack while Mix is selected
      if (id !== 'valuepack' && selectedFlavor === 'mix') {
        selectedFlavor = 'mango';
        document.querySelectorAll('.fl-btn, .flavor-pill').forEach(function(b) {
          if (b.dataset.mix) return;
          var isMango = b.textContent.trim().toLowerCase() === 'mango';
          b.classList.toggle('on', isMango);
          b.style.background = isMango ? (b.dataset.color || '#e6264d') : '';
          b.style.borderColor = isMango ? (b.dataset.color || '#e6264d') : '';
          b.style.color = isMango ? '#fff' : '';
        });
      }
      updateHeroImage();
    });
  }
}

var aanbodIdx = 0;

function aanbodGoTo(idx) {
  var container = document.getElementById('aanbodThumbs');
  var thumbs = container ? container.querySelectorAll('.aanbod-thumb') : [];
  if (!thumbs.length) return;
  aanbodIdx = (idx + thumbs.length) % thumbs.length;
  // Read layout values before rAF to avoid layout thrashing
  var src = thumbs[aanbodIdx].querySelector('img').dataset.full;
  var thumbWidth = thumbs[0].offsetWidth;
  var targetIdx = aanbodIdx;
  requestAnimationFrame(function() {
    var img = document.getElementById('aanbodImg');
    if (img && src) {
      img.style.opacity = '0';
      setTimeout(function() { img.src = src; img.style.opacity = '1'; }, 180);
    }
    thumbs.forEach(function(t, i) { t.classList.toggle('active', i === targetIdx); });
    container.scrollLeft = targetIdx * (thumbWidth + 10);
  });
}

function switchAanbodImg(thumb, src) {
  var idx = parseInt(thumb.dataset.idx) || 0;
  aanbodGoTo(idx);
}

// ── FLAVOR PICKER (Homepage aanbod) ──
function pickFlavor(btn) {
  var group = btn.closest('.flavor-btns');
  if (!group) return;
  group.querySelectorAll('.fl-btn').forEach(function(b) {
    b.classList.remove('on');
    b.style.background = '';
    b.style.borderColor = '';
    b.style.color = '';
  });
  btn.classList.add('on');
  var color = btn.dataset.color;
  if (color) { btn.style.background = color; btn.style.borderColor = color; btn.style.color = '#fff'; }
  updateHeroImage();
}

// ── PRODUCT PAGE FUNCTIONS ──
var qty = 1;
var selectedFlavor = 'mango';
var selectedPakket = '1pot';

function changeQty(d) {
  qty = Math.max(1, qty + d);
  var el = document.getElementById('qtyNum');
  if (el) el.textContent = qty;
  var qtyInput = document.getElementById('qty-input');
  if (qtyInput) qtyInput.value = qty;
}

function updateVariantInput() {
  var variantsData = selectedPakket === 'abonnement'
    ? (window.__subscriptionVariants || window.__productVariants)
    : window.__productVariants;
  if (!variantsData || !variantsData.length) return;

  var flavorKey = selectedFlavor.toLowerCase();
  var variant = null;

  for (var i = 0; i < variantsData.length; i++) {
    if (variantsData[i].title.toLowerCase().indexOf(flavorKey) !== -1) {
      variant = variantsData[i];
      break;
    }
  }
  if (!variant) variant = variantsData[0];

  var input = document.getElementById('variant-id-input');
  if (input && variant) input.value = variant.id;
}

function addToCart() {
  var btn = document.querySelector('.add-cart-btn') || document.getElementById('pakketCta');
  if (!btn) return;

  var variantsData = selectedPakket === 'abonnement'
    ? (window.__subscriptionVariants || window.__productVariants)
    : window.__productVariants;

  // Varianten nog niet geladen: haal op via Shopify AJAX API
  if (!variantsData || !variantsData.length) {
    var fetchHandle = selectedPakket === 'abonnement' ? 'ndeavour-abonnement' : 'ndeavour';
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';
    fetch('/products/' + fetchHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (!product || !product.variants || !product.variants.length) throw new Error('no variants');
        if (selectedPakket === 'abonnement') {
          window.__subscriptionVariants = product.variants;
          if (product.selling_plan_groups && product.selling_plan_groups.length) {
            window.__subscriptionSellingPlanId = product.selling_plan_groups[0].selling_plans[0].id;
          }
        } else {
          window.__productVariants = product.variants;
        }
        btn.disabled = false;
        btn.textContent = 'In winkelwagen';
        addToCart();
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'In winkelwagen';
        alert('Er ging iets mis. Probeer het opnieuw.');
      });
    return;
  }

  var variant = null;
  var flavorKey = selectedFlavor.toLowerCase();

  // Alias-matching zodat "1 pot", "2 potten" etc. ook matchen
  var pakketAliases = {
    'abonnement': ['abonnement', 'abo'],
    'valuepack':  ['valuepack', 'value pack', '2 pot', '2pot', '2potten', '2 potten', 'dubbel', 'bundel'],
    '1pot':       ['1pot', '1 pot', 'enkel', 'los', 'single']
  };
  var aliases = pakketAliases[selectedPakket] || [selectedPakket];

  // 1. Smaak + pakket-alias
  for (var a = 0; a < aliases.length && !variant; a++) {
    for (var i = 0; i < variantsData.length; i++) {
      var title = variantsData[i].title.toLowerCase();
      if (title.indexOf(flavorKey) !== -1 && title.indexOf(aliases[a]) !== -1) {
        variant = variantsData[i];
        break;
      }
    }
  }

  // 2. Fallback: smaak alleen
  if (!variant) {
    for (var j = 0; j < variantsData.length; j++) {
      if (variantsData[j].title.toLowerCase().indexOf(flavorKey) !== -1 && variantsData[j].available) {
        variant = variantsData[j];
        break;
      }
    }
  }

  // 3. Fallback: eerste beschikbare variant
  if (!variant) {
    variant = variantsData.filter(function(v) { return v.available; })[0] || variantsData[0];
  }

  if (!variant) return;

  btn.disabled = true;
  btn.textContent = 'Toevoegen...';

  var cartPayload = { id: variant.id, quantity: qty };
  if (selectedPakket === 'abonnement' && window.__subscriptionSellingPlanId) {
    cartPayload.selling_plan = window.__subscriptionSellingPlanId;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartPayload)
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status && data.status !== 200) {
      throw new Error(data.description || 'Fout');
    }
    window.location = '/cart';
  })
  .catch(function(err) {
    btn.disabled = false;
    btn.textContent = 'In winkelwagen';
    alert('Er ging iets mis bij het toevoegen. Probeer het opnieuw.');
  });
}

function updateThumbVisibility() {} // no-op, replaced by scroll-based approach

// ── PER-CARD GALLERY ──
function switchCardImg(id, el, index) {
  var slider = document.getElementById('slider-' + id);
  if (!slider) return;
  slider.scrollTo({ left: slider.offsetWidth * index, behavior: 'smooth' });
  document.querySelectorAll('#thumbs-' + id + ' .card-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}
function shiftCardThumbs(id, dir) {
  var thumbs = Array.from(document.querySelectorAll('#thumbs-' + id + ' .card-thumb'));
  var total = thumbs.length;
  var activeIndex = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
  var newIndex = (activeIndex + dir + total) % total;
  switchCardImg(id, thumbs[newIndex], newIndex);
}

function switchImg(el, index) {
  var slider = document.getElementById('prodSlider');
  if (!slider) return;
  // Read layout values first, then write in rAF to avoid layout thrashing
  var sliderWidth = slider.offsetWidth;
  var container = document.getElementById('prodThumbs');
  var thumbs = Array.from(document.querySelectorAll('#prodThumbs .prod-thumb'));
  var thumbWidth = (container && thumbs.length) ? thumbs[0].offsetWidth : 0;
  requestAnimationFrame(function() {
    slider.scrollTo({ left: sliderWidth * index, behavior: 'smooth' });
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (el) el.classList.add('active');
    if (container && thumbWidth) {
      container.scrollLeft = index * (thumbWidth + 8);
    }
  });
}

function shiftThumbs(dir) {
  var thumbs = Array.from(document.querySelectorAll('#prodThumbs .prod-thumb'));
  if (!thumbs.length) return;
  var activeIndex = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
  var newIndex = (activeIndex + dir + thumbs.length) % thumbs.length;
  switchImg(thumbs[newIndex], newIndex);
}

var _galleryBaseUrl = null;

function _getBaseUrl() {
  if (_galleryBaseUrl) return _galleryBaseUrl;
  // Try shop page first image, then homepage main image
  var ref = document.querySelector('#prodSlider img') || document.getElementById('aanbodImg');
  if (ref) {
    var src = ref.src;
    _galleryBaseUrl = src.substring(0, src.lastIndexOf('/') + 1);
  }
  return _galleryBaseUrl;
}

function updateHeroImage() {
  var baseUrl = _getBaseUrl();
  if (!baseUrl) return;
  var flavor = (typeof selectedFlavor !== 'undefined') ? selectedFlavor : 'mango';
  var pakket = (typeof selectedPakket !== 'undefined') ? selectedPakket : 'abonnement';
  var imgName = flavor + ((pakket === 'valuepack' || flavor === 'mix') ? '-dubbel-v2' : '-enkel-v2') + '.png';
  var newSrc = baseUrl + imgName;

  // Shop page gallery
  var firstSliderImg = document.querySelector('#prodSlider img');
  var firstThumb = document.querySelector('#prodThumbs .prod-thumb');
  if (firstSliderImg) firstSliderImg.src = newSrc;
  if (firstThumb) { firstThumb.src = newSrc; firstThumb.alt = imgName; switchImg(firstThumb, 0); }

  // Homepage gallery
  var aanbodImg = document.getElementById('aanbodImg');
  if (aanbodImg) {
    var firstAanbodThumb = document.querySelector('#aanbodThumbs .aanbod-thumb img');
    if (firstAanbodThumb) { firstAanbodThumb.src = newSrc; firstAanbodThumb.dataset.full = newSrc; }
    // Set image directly without opacity animation to avoid timing conflicts
    aanbodImg.src = newSrc;
    aanbodIdx = 0;
    var aanbodContainer = document.getElementById('aanbodThumbs');
    if (aanbodContainer) {
      aanbodContainer.querySelectorAll('.aanbod-thumb').forEach(function(t, i) {
        t.classList.toggle('active', i === 0);
      });
      aanbodContainer.scrollLeft = 0;
    }
  }
}

function pickProdFlavor(btn, flavor) {
  document.querySelectorAll('.prod-flavor-pick .flavor-pill').forEach(function(b) {
    b.classList.remove('on');
    b.style.background = '';
    b.style.borderColor = '';
    b.style.color = '';
  });
  btn.classList.add('on');
  var color = btn.dataset.color;
  if (color) { btn.style.background = color; btn.style.borderColor = color; btn.style.color = '#fff'; }
  if (flavor) selectedFlavor = flavor;
  updateHeroImage();
  updateVariantInput();
}

function pickPkg(card, price, sub) {
  document.querySelectorAll('.pkg-card').forEach(function(c) { c.classList.remove('on'); });
  card.classList.add('on');
  var priceEl = document.getElementById('priceDisplay');
  var subEl = document.getElementById('priceSub');
  if (priceEl) priceEl.textContent = price;
  if (subEl) subEl.textContent = sub;
}

function switchTab(btn, tabId) {
  document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('on'); });
  document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('on'); });
  btn.classList.add('on');
  var panel = document.getElementById(tabId);
  if (panel) panel.classList.add('on');
}

function toonMeerReviews() {
  var extra = document.getElementById('extraReviews');
  var btn = document.getElementById('toonMeerBtn');
  if (extra) extra.style.display = 'grid';
  if (btn) btn.style.display = 'none';
}

// ── REVIEW FORM ──
var selectedStars = 0;

function initStarPicker() {
  document.querySelectorAll('.star-pick').forEach(function(star) {
    star.addEventListener('mouseover', function() {
      var val = parseInt(this.dataset.val);
      document.querySelectorAll('.star-pick').forEach(function(s, i) {
        s.style.color = i < val ? 'var(--orange)' : 'rgba(24,6,56,0.2)';
      });
    });
    star.addEventListener('click', function() {
      selectedStars = parseInt(this.dataset.val);
    });
  });
  var picker = document.getElementById('starPicker');
  if (picker) {
    picker.addEventListener('mouseleave', function() {
      document.querySelectorAll('.star-pick').forEach(function(s, i) {
        s.style.color = i < selectedStars ? 'var(--orange)' : 'rgba(24,6,56,0.2)';
      });
    });
  }
}

function submitReview(e) {
  e.preventDefault();
  var form = document.getElementById('reviewForm');
  var success = document.getElementById('reviewSuccess');
  if (form) form.style.display = 'none';
  if (success) success.style.display = 'block';
}

// ── SCROLL FADE IN ──
function initScrollFade() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        e.target.classList.add('visible');
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.ing-card, .sporter-card, .review-card, .aanbod-card, .vtw-card, .fade-in, .why-card, .usage-step, .team-card, .cert-card, .value-card').forEach(function(el) {
    if (!el.classList.contains('fade-in')) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    }
    io.observe(el);
  });
}

// ── PRODUCT SLIDER SYNC ──
function initProductSlider() {
  var slider = document.getElementById('prodSlider');
  if (slider) {
    slider.addEventListener('scroll', function() {
      var index = Math.round(this.scrollLeft / this.offsetWidth);
      document.querySelectorAll('.prod-thumb').forEach(function(t, i) {
        t.classList.toggle('active', i === index);
      });
    });
  }
}

// ── MOUSE DRAG FOR SCROLL CONTAINERS ──
function addMouseDrag(el) {
  if (!el) return;
  var isDown = false, startX = 0, scrollLeft = 0;
  el.style.cursor = 'grab';
  el.addEventListener('mousedown', function(e) {
    isDown = true;
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
    e.preventDefault();
  });
  el.addEventListener('mouseleave', function() { isDown = false; el.style.cursor = 'grab'; });
  el.addEventListener('mouseup', function() { isDown = false; el.style.cursor = 'grab'; el.style.userSelect = ''; });
  el.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - el.offsetLeft;
    el.scrollLeft = scrollLeft - (x - startX) * 1.5;
  });
}

// ── TOPSPORTER SPOTLIGHT SLIDER ──
var ssIndex = 0;
function ssUpdate() {
  var track = document.querySelector('.ss-track');
  if (!track) return;
  track.style.transform = 'translateX(-' + ssIndex * 100 + '%)';
  document.querySelectorAll('.ss-dot').forEach(function(d, i) {
    d.classList.toggle('active', i === ssIndex);
  });
}
function ssPrev() {
  var total = document.querySelectorAll('.ss-slide').length;
  ssIndex = (ssIndex - 1 + total) % total;
  ssUpdate();
}
function ssNext() {
  var total = document.querySelectorAll('.ss-slide').length;
  ssIndex = (ssIndex + 1) % total;
  ssUpdate();
}
function ssGo(i) { ssIndex = i; ssUpdate(); }

// ── DOM READY ──
document.addEventListener('DOMContentLoaded', function() {
  // Nav hamburger
  var btn = document.getElementById('hamburger');
  if (btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleMenu();
    });
  }
  document.addEventListener('click', function(e) {
    if (!e.target.closest('nav') && !e.target.closest('#navDropdown')) closeMenu();
  });

  // FAQ
  initFaq();

  // Scroll fade
  initScrollFade();

  // Product slider
  initProductSlider();

  // Star picker
  initStarPicker();

  // Thumb visibility
  if (document.querySelector('.prod-thumb')) {
    updateThumbVisibility();
  }

  // UGC carousel
  if (window.innerWidth > 900) { ugcUpdate(); } else { ugcMobileInit(); }

  // Topsporter spotlight slider swipe
  var ssTrack = document.querySelector('.ss-track');
  if (ssTrack) {
    var ssTouchX = 0, ssMouseX = 0, ssMouseDown = false;
    ssTrack.addEventListener('touchstart', function(e) { ssTouchX = e.touches[0].clientX; }, { passive: true });
    ssTrack.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - ssTouchX;
      if (Math.abs(dx) < 40) return;
      dx < 0 ? ssNext() : ssPrev();
    }, { passive: true });
    ssTrack.addEventListener('mousedown', function(e) { ssMouseDown = true; ssMouseX = e.clientX; ssTrack.style.cursor = 'grabbing'; e.preventDefault(); });
    document.addEventListener('mouseup', function(e) {
      if (!ssMouseDown) return;
      ssMouseDown = false; ssTrack.style.cursor = '';
      var dx = e.clientX - ssMouseX;
      if (Math.abs(dx) < 40) return;
      dx < 0 ? ssNext() : ssPrev();
    });
  }

  // Mouse drag for all horizontal scroll containers
  ['.aanbod-grid', '.sporter-grid', '.review-grid', '#prodSlider', '.objection-split-items'].forEach(function(sel) {
    document.querySelectorAll(sel).forEach(addMouseDrag);
  });

  // Aanbod hoofdfoto swipe (touch + muis)
  var aanbodMain = document.querySelector('.aanbod-main-img');
  if (aanbodMain) {
    var aTouchX = 0, aMouseX = 0, aMouseDown = false;
    aanbodMain.addEventListener('touchstart', function(e) { aTouchX = e.touches[0].clientX; }, { passive: true });
    aanbodMain.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - aTouchX;
      if (Math.abs(dx) < 40) return;
      dx < 0 ? aanbodGoTo(aanbodIdx + 1) : aanbodGoTo(aanbodIdx - 1);
    }, { passive: true });
    aanbodMain.addEventListener('mousedown', function(e) {
      aMouseDown = true; aMouseX = e.clientX;
      aanbodMain.classList.add('grabbing'); e.preventDefault();
    });
    document.addEventListener('mouseup', function(e) {
      if (!aMouseDown) return;
      aMouseDown = false; aanbodMain.classList.remove('grabbing');
      var dx = e.clientX - aMouseX;
      if (Math.abs(dx) < 40) return;
      dx < 0 ? aanbodGoTo(aanbodIdx + 1) : aanbodGoTo(aanbodIdx - 1);
    });
  }

  // Aanbod thumbnail strip muis drag
  var aanbodThumbs = document.getElementById('aanbodThumbs');
  if (aanbodThumbs) {
    var tMouseX = 0, tScrollLeft = 0, tDown = false;
    aanbodThumbs.addEventListener('mousedown', function(e) {
      tDown = true; tMouseX = e.pageX; tScrollLeft = aanbodThumbs.scrollLeft;
      aanbodThumbs.classList.add('grabbing'); e.preventDefault();
    });
    document.addEventListener('mouseup', function() {
      tDown = false; aanbodThumbs.classList.remove('grabbing');
    });
    aanbodThumbs.addEventListener('mousemove', function(e) {
      if (!tDown) return;
      aanbodThumbs.scrollLeft = tScrollLeft - (e.pageX - tMouseX);
    });
  }
});


// ── Sticky product gallery (scroll-based) ──
function initStickyGallery() {
  var gallery = document.querySelector('#prod-buy .prod-gallery');
  var section = document.querySelector('#prod-buy');
  if (!gallery || !section || window.innerWidth < 900) return;

  var TOP_OFFSET = 140; // just below fixed header with breathing room
  var stickyThreshold, maxShift;

  function init() {
    gallery.style.transform = '';
    var gRect = gallery.getBoundingClientRect();
    var sRect = section.getBoundingClientRect();
    var scrollY = window.scrollY || window.pageYOffset;
    // scroll position at which gallery top reaches TOP_OFFSET
    stickyThreshold = gRect.top + scrollY - TOP_OFFSET;
    // max pixels we can shift before gallery bottom hits section bottom
    maxShift = Math.max(0, sRect.bottom - gRect.top - gallery.offsetHeight - 20);
  }

  var ticking = false;
  function update() {
    if (window.innerWidth < 900) { gallery.style.transform = ''; return; }
    var scrollY = window.scrollY || window.pageYOffset;
    if (scrollY <= stickyThreshold) { gallery.style.transform = ''; return; }
    var shift = Math.min(scrollY - stickyThreshold, maxShift);
    gallery.style.transform = 'translateY(' + shift + 'px)';
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(function() { update(); ticking = false; }); ticking = true; }
  }

  window.addEventListener('load', function() { init(); update(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function() { init(); update(); }, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyGallery);
} else {
  initStickyGallery();
}
